/**
* 题目一览
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题目一览</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search" :rules="searchRules">
      <el-form-item label="题库">
        <el-select size="small" v-model="searchForm.parentId" placeholder="请选择题库">
          <el-option
            v-for="item in questionBankList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="题目">
        <el-input size="small" v-model="searchForm.name" placeholder="输入题目" style="width:500px"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <template>
      <div>
        <vxe-table border max-height="950" :data="listData" v-loading="loading" element-loading-text="拼命加载中">
          <vxe-column type="seq" width="60"></vxe-column>
          <vxe-column field="name" title="标题" show-header-overflow show-overflow show-footer-overflow></vxe-column>
          <vxe-column field="parentId" title="所属题库" :formatter="parentFormatter" width="180"></vxe-column>
          <vxe-column field="createTime" title="修改时间" width="180"></vxe-column>
          <vxe-column field="address" title="操作" width="180">
            <template v-slot:default="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </template>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="所属题库" prop="name">
          <el-select size="small" v-model="editForm.parentId" placeholder="请选择题库" :disabled="editForm.id!=''">
            <el-option
              v-for="item in questionBankList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input size="small" type="textarea" v-model="editForm.name" auto-complete="off" placeholder="请输入名称"
                    :rows="8" :max="250"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {questionBankList, questionDelete, questionListByPage, questionSave} from '../../api/api'

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        id: '',
        parentId: '',
        name: ''
      },
      // rules表单验证
      rules: {
        name: [
          {required: true, message: '请输入题目', trigger: 'blur'}
        ]
      },
      searchRules: {
        parentId: [
          {required: true, message: '请选择题库', trigger: 'change'}
        ]
      },
      searchForm: {
        parentId: null,
        name: ''
      },
      // 题库下拉
      questionBankList: [],
      // 一览数据
      listData: []
    }
  },
  watch: {
    editFormVisible(newVal,oldVal) {
        if (!newVal) {
            this.search();
        }
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.questionBankDropDown();
  },

  methods: {
    questionBankDropDown() {
      questionBankList({deleteFlg: 0})
        .then(res => {
          this.questionBankList = res.data
          if (this.questionBankList && this.questionBankList.length > 0) {
            this.searchForm.parentId = this.questionBankList[0].id
          }
          this.getData(this.searchForm)
        })
        .catch(err => {
          this.loading = false
          this.$message.error('下拉列表查询失败！')
        })
    },
    // 获取题目列表
    getData(parameter) {

      this.loading = true
      questionListByPage(parameter)
        .then(res => {
          this.loading = false
          this.listData = res.data
        })
        .catch(err => {
          this.loading = false
          this.$message.error('查询失败！')
        })
    },
    // 搜索事件
    search() {
      if (!this.searchForm.parentId) {
        this.$message.error('查询条件请选择一个题库');
        return;
      }
      this.getData(this.searchForm)
    },
    //显示编辑界面
    handleEdit (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.parentId = row.parentId
        this.editForm.name = row.name
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.parentId = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      let id = (this.editForm || {}).id;
      this.$refs[editData].validate(valid => {
        if (valid) {
          questionSave(this.editForm)
            .then(res => {
              this.loading = false
              if (id) {
                this.editFormVisible = false
                if (res.code === 200) {
                  this.getData(this.searchForm)
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              } else {
                if (res.code === 200) {
                  this.editForm.name = ''
                  this.$message({
                    type: 'success',
                    message: '保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除题目
    handleDelete(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          questionDelete(row.id)
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '题目已删除!'
                })
                this.getData(this.searchForm)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 题库格式化
    parentFormatter({cellValue}) {
      const item = this.questionBankList.find(item => item.id === cellValue)
      return item ? item.name : cellValue
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/questions/Question.vue